import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import zh from './locales/zh.json';
import hi from './locales/hi.json';
import ar from './locales/ar.json';
import ja from './locales/ja.json';

const resources = {
  en: { translation: en },
  es: { translation: es },
  pt: { translation: pt },
  zh: { translation: zh },
  hi: { translation: hi },
  ar: { translation: ar },
  ja: { translation: ja },
  fr: { translation: fr },
};

// Top 8 strategic languages covering ~80% of global betting + crypto users:
//  - English (Global default — US/UK/AU/CA/IN/AF)
//  - Spanish (LatAm + Spain)
//  - Portuguese (Brazil — explosive market)
//  - Chinese Simplified (China + diaspora)
//  - Hindi (India — crypto + cricket boom)
//  - Arabic (MENA region)
//  - Japanese (Japan — high-value market)
//  - French (France + Francophone Africa)
export const LANGUAGES = [
  { code: 'en', name: 'English', flag: 'US' },
  { code: 'es', name: 'Espa\u00f1ol', flag: 'ES' },
  { code: 'pt', name: 'Portugu\u00eas', flag: 'BR' },
  { code: 'zh', name: '\u4e2d\u6587', flag: 'CN' },
  { code: 'hi', name: '\u0939\u093f\u0928\u094d\u0926\u0940', flag: 'IN' },
  { code: 'ar', name: '\u0627\u0644\u0639\u0631\u0628\u064a\u0629', flag: 'SA' },
  { code: 'ja', name: '\u65e5\u672c\u8a9e', flag: 'JP' },
  { code: 'fr', name: 'Fran\u00e7ais', flag: 'FR' },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'pt', 'zh', 'hi', 'ar', 'ja', 'fr'],
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'bet4peer_lang',
    },
  });

export default i18n;
